import axiosInstance from "./api/axiosInstance";

const API_URL = 'https://blogapi.wajok.com/api';

const boardList = async () => {
    try {
        const response = await axiosInstance.get(`${API_URL}/board`);
        return response.data;
    } catch (error) {
        throw new Error(`error : ${error}`);
    }
}

const hospitalEmergency = async (region, subRegion) => {
    try {
        const response = await axiosInstance.get(`https://apis.data.go.kr/B552657/ErmctInfoInqireService/getEmrrmRltmUsefulSckbdInfoInqire?serviceKey=WH3rCrAO12XZos%2B%2BZ4%2FQrU2BnN60h8kdMHU%2FPgbBi3anKDHcWL03M7okYqUKv6bG%2FyajxPRKKVDNW9P3FJddbw%3D%3D&STAGE1=${region}&STAGE2=${subRegion}`, {
            headers: {
                'Accept': 'application/xml',
            }
        });

        return response.data;
    } catch (error) {
        throw Error(`hospital error : ${error}`);
    }
}

export { boardList, hospitalEmergency };